import React from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass';

import { TableCell } from '../TableComponents';
import { Text, Number, Icon } from '../../Base';

const CustomTableCell = styled(TableCell)`
  && {
    overflow: unset;
    height: 100px;
  }
`;
const ScorePointer = ({ score, color }) => (
  <CustomTableCell>
    <Flex
      flexDirection={'column'}
      alignItems={'center'}
      style={{
        position: 'absolute',
        top: '0',
        right: '50%',
        transform: 'translateX(50%)',
        width: '120px',
      }}
    >
      <Icon
        name={'arrow_drop_up'}
        iconStyle={{ color: color, height: '0.75em' }}
        fontSize={'36px'}
      />
      <Text fontSize={1}>คะแนนที่ได้</Text>
      <Text fontSize={3}>
        <Number
          value={score} // variant={isMed ? 'fourDecimals' : 'twoDecimals'}
        />
      </Text>
      <Text fontSize={1}>อยู่ในช่วงนี้</Text>
    </Flex>
  </CustomTableCell>
);
export default ScorePointer;
